// The supplier database (shared with Tenders), loaded once and shared by the pages that offer suppliers to pick.
import { useEffect, useState } from './react.js';
import { API } from './api.js';

export const SUP_COLL = 'tenders/directory';
// the categories live with the plain supplier data, so code tested on its own can use them
export { SUP_CATS, supCat } from './supplier-links.js';
let cache = null, at = 0, pending = null;
const listeners = new Set();
export function loadSupplierDirectory(force = false) {
  if (!force && cache && Date.now() - at < 60000) return Promise.resolve(cache);
  if (!pending) pending = API.call('docList', { coll: SUP_COLL, known: {} }).then(d => {
    cache = Object.entries(d.docs || {}).filter(([id, x]) => id !== '_builtins' && x && x.name).map(([id, x]) => ({ ...x, id }));
    at = Date.now(); listeners.forEach(f => f(cache)); return cache;
  }).finally(() => { pending = null; });
  return pending;
}
// The Suppliers page calls this after a change, so other pages see it at once
export function supplierDirectoryChanged() { cache = null; loadSupplierDirectory(true).catch(() => {}); }
export function useSupplierDirectory() {
  const [list, setList] = useState(cache || []);
  useEffect(() => {
    listeners.add(setList);
    loadSupplierDirectory().then(setList).catch(() => {});
    return () => listeners.delete(setList);
  }, []);
  return list;
}
